import axios from '../utils/axios'

export function getInfo() {
  return axios.post('/login/apiLoginAh5Service/getInfo')
}
export function getUserInfo() {
  return axios.post('/user/apiUserAh5Service/getUserInfo2') //网关getUserInfo有限制，只能被迫改成getUserInfo2
}
// 获取h5主题色配置
export function getStoreTheme(params) {
  return axios.post('/user/apiUserAh5Service/storeTheme', params)
}
export function EditUserInfo(params) {
  return axios.put('/user/info', params)
}

export function login(params) {
  return axios.post('/user/login', params)
}

export function loginByToken(params) {
  return axios.post('/login/apiLoginAh5Service/loginByToken', params)
}

export function getAreaCodeListApi(params) {
  return axios.post('/login/apiLoginAh5Service/areaCodeList', params)
}

export function logout() {
  return axios.post('/user/logout')
}

export function register(params) {
  return axios.post('/user/register', params)
}

// 使用密码登录
export function loginByPassword(params) {
  return axios.post('/login/apiLoginAh5Service/loginByPassword', params)
}

// 使用短信验证码登录
export function loginBySmsVerifyCode(params) {
  return axios.post('/login/apiLoginAh5Service/loginBySmsVerifyCode', params)
}

// 发送登录短信登录验证码
export function sendSmsLoginVerifyCode(params) {
  return axios.post('/login/apiLoginAh5Service/sendSmsLoginVerifyCode', params)
}

// 设置提现密码短信验证码
export function sendSetPayPasswordVerifyCode(params) {
  return axios.post('/user/apiUserAh5Service/sendSetPayPasswordVerifyCode', params, { isTransformRes: false })
}
// 设置提现密码 /dsx_user/apiUserAh5Service/setPayPassword
export function setPayPassword(params) {
  return axios.post('/user/apiUserAh5Service/setPayPassword', params, { isTransformRes: false })
}
// 验证提现密码 /dsx_user/apiUserAh5Service/checkPayPassword
export function checkPayPassword(params) {
  return axios.post('/user/apiUserAh5Service/checkPayPassword', params, { isTransformRes: false })
}

export function checkAgentGradeRulesInfoByPuid(params) {
  return axios.post('/user/apiUserAh5Service/checkAgentGradeRulesInfoByPuid', params)
}

//获取店铺信息
export function getMemberStoreInfoApi(params) {
  return axios.post('/user/apiUserAwService/getMemberStore', params)
}
//更新店铺信息
export function updateStoreInfoApi(params) {
  return axios.post('/user/apiUserService/updateStoreInfo', params)
}

// 灵虎信签约查询
export function linghuoxinSignQueryApi(params) {
  return axios.post('/user/apiUserAh5Service/linghuoxinSignQuery', params)
}
// 云账户签约查询
export function yunzhanghuSignQueryApi(params) {
  return axios.post('/user/apiUserAh5Service/yunzhanghuSignQuery', params)
}
// 提现签名
export function xinyuanguojiSignApi(params = {}) {
  return axios.post('/user/apiUserAh5Service/xinyuanguojiSign', params)
}
